import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const HeavyWeightIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-heavyWeight"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M52.645072 13.8377069C52.790644 13.4135048 53.3620264 13.3901956 53.557813 13.7606866L53.5937264 13.8461025 57.6296238 26.3218289 56.6781711 26.6296238 53.104 15.58 49.3106349 26.6352212 48.3647788 26.3106349 52.645072 13.8377069ZM14.645072 1.83770686C14.790644 1.41350483 15.3620264 1.39019559 15.557813 1.76068662L15.5937264 1.84610252 19.6296238 14.3218289 18.6781711 14.6296238 15.104 3.58 11.3106349 14.6352212 10.3647788 14.3106349 14.645072 1.83770686Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <g transform="translate(8 1.986)">
          <path
            d="M14 11.0139C14 14.8799 10.866 18.0139 7 18.0139 3.134 18.0139 0 14.8799 0 11.0139L14 11.0139ZM52 23.0139C52 26.8799 48.866 30.0139 45 30.0139 41.134 30.0139 38 26.8799 38 23.0139L52 23.0139Z"
            fill="#0050B3"
            className={styles.interactiveColor}
          />
          <path
            d="M5.97158066,-0.300698216 C6.12578948,-0.789799675 6.62105999,-1.07682789 7.11275138,-0.982370739 L7.22599822,-0.953719342 L45.3749982,11.0742807 C45.9017229,11.2403517 46.1940904,11.8019736 46.0280193,12.3286982 C45.8738105,12.8177997 45.37854,13.1048279 44.8868486,13.0103707 L44.7736018,12.9817193 L6.62460178,0.953719342 C6.09787714,0.787648303 5.80550962,0.226026432 5.97158066,-0.300698216 Z"
            fill="#00000"
            className={styles.defaultColor}
            fillRule="nonzero"
          />
          <path
            d="M23,6.0139 C23,7.6709 24.343,9.0139 26,9.0139 C27.657,9.0139 29,7.6709 29,6.0139 C29,4.3569 27.657,3.0139 26,3.0139 C24.343,3.0139 23,4.3569 23,6.0139"
            fill="#00000"
            className={styles.defaultColor}
          />
          <path
            d="M26,1.0139 C26.5128358,1.0139 26.9355072,1.39994019 26.9932723,1.89727887 L27,2.0139 L27,28.0139 C27,28.5661847 26.5522847,29.0139 26,29.0139 C25.4871642,29.0139 25.0644928,28.6278598 25.0067277,28.1305211 L25,28.0139 L25,2.0139 C25,1.46161525 25.4477153,1.0139 26,1.0139 Z"
            fill="#00000"
            className={styles.defaultColor}
            fillRule="nonzero"
          />
          <path
            d="M20,30.0139 L32,30.0139 L32,30.0139 C32,28.9089 31.105,28.0139 30,28.0139 L22,28.0139 C20.895,28.0139 20,28.9089 20,30.0139 Z"
            fill="#00000"
            className={styles.defaultColor}
          />
        </g>
      </g>
    </Icon>
  )
}
